const columns = [
  { name: "Nome da turma", value: "name", filter: true },
  { name: "Quant. de alunos", value: "studentsAverage", filter: false },
  { name: "Quant. de cursos", value: "coursesAverage", filter: false },
  { name: "Status", value: "status", filter: false },
];

const columnsSelect = [
  { name: "Nome do usuário", value: "name", filter: true },
  { name: "E-mail", value: "login", filter: true },
];

const actions = [
  {
    title: null,
    icon: "hi-solid-pencil",
    type: "edit",
    style: "btn-simple",
    tooltip: "Editar",
  },
];

export { actions, columns, columnsSelect };
